var angular = require('angular');

export default angular.module('asBreadcrumb', []).component('asBreadcrumb', {
    template: require('./asBreadcrumb.component.html'),
    styleUrls: require('./asBreadcrumb.component.css'),
    bindings: {
        items: '<'
    }
});



// WEBPACK FOOTER //
// ./modules/shared/asBreadcrumb/asBreadcrumb.component.js